/** value in milliseconds */
export const ONE_SECOND = 1000;
